(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-privacy-open]').forEach(button => { button.hidden = false; });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-privacy-open]');
    if (!button || button.disabled) return;
    const footer = button.closest('[data-footer]');
    const message = footer?.querySelector('[data-privacy-message]');
    const status = footer?.querySelector('[data-privacy-status]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (message) message.hidden = true;
    let timeout;
    try {
      if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('unavailable');
      await Promise.race([
        Promise.resolve(window.privacyBanner.showPreferences()),
        new Promise((_, reject) => { timeout = window.setTimeout(() => reject(new Error('timeout')), 5000); })
      ]);
    } catch (_) {
      if (status) status.textContent = status.dataset.error;
      if (message) message.hidden = false;
    } finally {
      window.clearTimeout(timeout);
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
